// Utils
import { SearchPageContentPartial } from '../seo-serp-page';

// UI
import { Typography } from '@components/typography';

type Props = { searchPageContent?: SearchPageContentPartial };

export const SearchPageContentH1: React.FC<Props> = ({ searchPageContent }) => {
  if (!searchPageContent) {
    return null;
  }

  return (
    <div className="relative w-full text-left px-2 sm:px-0 pt-8 sm:pb-4">
      <Typography component="p" variant="title3" className="mb-4">
        {searchPageContent.h1}
      </Typography>
      <Typography
        component="p"
        className="text-black text-left text-md whitespace-pre-line"
      >
        {searchPageContent.h1ParagraphRaw}
      </Typography>
    </div>
  );
};
